import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { WeekPlanTotals } from '../../core/types/weekPlan';
import { renderColoredCell } from './WeekPlannerTable';

interface CarsSummaryTableProps {
  totals: WeekPlanTotals[];
}

export const MassSummaryTable = ({ totals }: CarsSummaryTableProps) => {
  const massColumns: GridColDef[] = [
    {
      field: 'readyMade',
      headerName: 'Ferdigvare',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#d6f5d6'),
    },
    {
      field: 'environmentalReadyMade',
      headerName: 'Miljø FV',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#d6f5d6'),
    },
    {
      field: 'blastedRockIn',
      headerName: 'Sprenst',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#d6f5d6'),
    },
    {
      field: 'mixedQuality',
      headerName: 'Sams',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#e3f2fd'),
    },
    {
      field: 'dumping',
      headerName: 'Tippmasse',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#e3f2fd'),
    },
    {
      field: 'washing',
      headerName: 'Vaskemasse',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#e3f2fd'),
    },
    {
      field: 'contaminated',
      headerName: 'Foruma',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#e3f2fd'),
    },
    {
      field: 'blastedRockOut',
      headerName: 'Sprenst',
      flex: 1,
      sortable: false,
      type: 'number',
      renderCell: (params) => renderColoredCell(params, '#e3f2fd'),
    },
  ];

  return (
    <DataGrid
      rows={totals}
      columns={massColumns}
      getRowId={(row) => row.readyMade}
      autoHeight
      hideFooter
      disableColumnMenu
      sx={{
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-cell': {
          padding: 0,
        },
      }}
    />
  );
};
